import CryptoJs from 'crypto-js'
const projectId = '1B63B161-1B62-4610-8794-C70D45BDAF9C'
const key = 'LUPGHODKYFWYO0YARAWNTKMM8QZQ8L1BA7ZMLEAE53V6NQS7ZWJ1WU' // 公钥
const cbcKey = 'hfcqef6702314589'
const cbcIv = 'bjertg6702394158'
export default {
    cbcEnccrypt (data) {
		var ckey = CryptoJs.enc.Utf8.parse(cbcKey)
        var iv = CryptoJs.enc.Utf8.parse(cbcIv)
		console.log(ckey)
		console.log(iv)
		console.log(CryptoJs.mode.CBC)
		console.log(CryptoJs.pad.Pkcs7)
		var encrypted = CryptoJs.AES.encrypt(data,ckey,{
            iv:iv,
            mode: CryptoJs.mode.CBC,
            padding: CryptoJs.pad.Pkcs7
        })
        return encrypted
    },
    cbcDecrypt (value) {
        var ckey = CryptoJs.enc.Utf8.parse(cbcKey)
        var iv = CryptoJs.enc.Utf8.parse(cbcIv)
        var decrypted =CryptoJs.AES.decrypt(value,ckey,{
            iv:iv,
            mode:CryptoJs.mode.CBC,
            padding:CryptoJs.pad.Pkcs7
        })
        return decrypted.toString(CryptoJs.enc.Utf8);
    },
    // 加密
    Encrypt (value, key) {
        var encryptText = CryptoJs.AES.encrypt(value, this.getKey(key)).toString()
        return encryptText
    },
    // 解密
    Decrypt (value, key) {
        var bytes = CryptoJs.AES.decrypt(value, this.getKey(key))
        var originalText = bytes.toString(CryptoJs.enc.Utf8)
        return originalText
    },
    getKey (aceKey) {
        if (aceKey === null || aceKey === undefined) {
            aceKey = ''
        }
        aceKey = aceKey + projectId.substring(1, 4) + key.substring(2, 10)
        return aceKey
    }
}